import React, { useState } from 'react'
import { ComponentView } from 'components/common/componentView'
import { config } from 'configs'
import {
  // FavouriteList,
  InactiveList,
  MyFundraiser,
} from './components/FundraiserList'

const Fundraisers = () => {
  const [searchText, setSearchText] = useState(null)
  const [sortSwitchValue, setSortSwitchValue] = useState(false)
  const [sortKey, setSortKey] = useState('createdDate')

  const heading = 'Fundraisers'
  const optionList = {
    my: <MyFundraiser searchText={searchText} sortKey={sortKey} />,
    inactive: <InactiveList searchText={searchText} sortKey={sortKey} />,
    // favorite: <FavouriteList searchText={searchText} sortKey={sortKey} />,
  }
  const createButtonLink = '/settings/create-fundraiser'
  const createTapButtonLink = '/settings/create-tap-fundraiser'

  const sortFilterData = [
    {
      label: 'Alphabetically',
      value: 'title',
      showOn: ['all', 'my', 'inactive', 'presenter', 'favorite'],
    },
    {
      label: 'Newest First',
      value: 'createdDate',
      showOn: ['all', 'my', 'inactive', 'presenter', 'favorite'],
    },
    {
      label: 'By Favorite Date',
      value: 'favDate',
      showOn: ['favorite'],
    },
  ]

  return (
    <ComponentView
      component={config.components.fundraiser}
      heading={heading}
      optionList={optionList}
      type="fundraiser"
      createButtonLink={createButtonLink}
      createTapButtonLink={createTapButtonLink}
      setSearchText={setSearchText}
      sortFilterData={sortFilterData}
      sortKey={sortKey}
      setSortKey={setSortKey}
      sortSwitchValue={sortSwitchValue}
      setSortSwitchValue={setSortSwitchValue}
    />
  )
}

export { Fundraisers }
